export const CONFIG = {
	IS_SERVER: true,
	API_URL: "https://access.gscbs.ru/api/",
	SHOW_PERSONS: false,
	SHOW_LOCATIONS: true,
	BLUE_OR_GREEN_DESIGN: true,
	MAP_INDIVIDUAL_PLACEMARKS: false,
	MAP_GENERATOR: false,
	SHOW_SEARCH2: true,
	YM_COUNTER: 106387340,

	MAIN_PAGE: {
	HEADER: 'Доступность учреждений культуры Санкт-Петербурга',
    HEADER1: 'Доступность учреждений',
    HEADER2: 'культуры Санкт-Петербурга',
	  },

	  PAGES_CARDS: {
		MAP_PAGE: {
		  HEADER: 'Карта',
		  TEXT: 'На интерактивной карте Санкт-Петербурга представлены учреждения культуры нашего города с описанием их доступности. Для вашего удобства карта снабжена системой фильтров, которая поможет быстро сориентироваться по видам доступности, типам учреждений и категориям ОВЗ.',
		},
		ABOUT_PAGE: {
		  HEADER: 'О проекте',
		  TEXT: 'Ресурс создан Санкт-Петербургской государственной специальной центральной библиотекой для слепых и слабовидящих и представляет собой систематизированные сведения о доступности учреждений культуры города, а также о наличии специальных и инклюзивных проектов, реализуемых этими учреждениями (библиотеками, музеями, театрами, концертными организациями). Сведения для ресурса библиотека получает от самих учреждений культуры в ходе мониторинга. Этот мониторинг включает сведения как о физической доступности зданий, так и о проектной деятельности. Информация, размещенная на ресурсе, корректируется и дополняется по мере поступления актуальных сведений.',
		},
		ORGANIZATIONS_PAGE: {
		  HEADER: 'Организации',
		  TEXT: 'Раздел содержит алфавитный список учреждений культуры. Каждое название является ссылкой, перейдя по которой можно узнать о проектной деятельности этого учреждения.',
		},
		LOCATIONS_PAGE: {
		  HEADER: 'Адреса',
		  TEXT: 'Раздел содержит алфавитный список адресов. Каждое название является ссылкой, перейдя по которой можно получить информацию о физической доступности здания по этому адресу.',
		},
		PERSONS_PAGE: {
		  HEADER: 'Люди',
		  TEXT: 'Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди Описание раздела Люди ',
		},
	  },

	ABOUT_PAGE: [""],
	
	ORGANIZATION_PAGE: {
		INFO:"Мероприятия",
		LOCATIONS: "Адрес",
		CATEGORIES: "",
		ALT_NAMES: "Другие названия",
		PERSONS: "Связи с людьми",
		ORGANIZATIONS: "Связи с другими организациями",
		LINKS: "Контакты"
	},

	PERSON_PAGE: {
		INFO: "Справка",
		LINKS:"Читаем по теме",
		PERSONS: "Связи с людьми",
		ORGANIZATIONS: "Связи с организациями",
	},

	LOCATION_PAGE: {
		INFO: "Доступность",
		DATES: "Даты постройки",
		ALT_NAMES: "Другие названия",
		PERSONS: "Архитекторы",
		LINKS: "Читаем по теме",
		ORGANIZATIONS: "В здании находятся"
	},

	CONTACTS:{
		ADDRESS: {
			TEXT:"Санкт-Петербург, ул.Стрельнинская, дом 11",
			LINK: "https://yandex.ru/maps/-/CDFfZ87-"
		},
		PHONE: {
			TEXT:"(812) 417-52-32",
			LINK:"tel:+78124175232"
		},
		EMAIL: {
			TEXT:"tiflo_otdel@gscbs.ru",
			LINK:"mailto:tiflo_otdel@gscbs.ru"
		},
		WEBSITE: {
			TEXT:"www.gbs.spb.ru",
			LINK:"https://www.gbs.spb.ru"
		}
	}
}